module.exports = __webpack_public_path__ + "img/happy-store.2da3bb10.png";